import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Area } from 'src/app/_models/area.model';
import { IServiceProvider } from 'src/app/_models/center.model';
import { City } from 'src/app/_models/city.model';
import { FullPatient, IFinglodineSubscriptionData, IPersonalInfo, ISubscriptionUploadsModel, PatientSubscription } from 'src/app/_models/patient.model';
import { PSPPatientService } from 'src/app/_services/PSP/patient.service';
import { AreaService } from 'src/app/_services/area.service';
import { CentersService } from 'src/app/_services/centers.service';
import { CityService } from 'src/app/_services/city.service';
import { FilesService } from 'src/app/_services/files/files.service';
import { PatientService } from 'src/app/_services/patient.service';
import { UploadingToolFileTypesEnum } from 'src/app/enums/uploading-tool-file-type-enums';
import { showNotification } from 'src/app/helpers/show-toast';
import { ViewAttachmentComponent } from '../view-attachment/view-attachment.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-view-edit-subscription',
  templateUrl: './view-edit-subscription.component.html',
  styleUrls: ['./view-edit-subscription.component.scss']
})
export class ViewEditSubscriptionComponent implements OnInit {

  patient = {} as FullPatient;
  patientId: number = 0;
  PSPpatientSubscription: PatientSubscription;
  patientInfo: IPersonalInfo;
  subscriptionId: number = 0;
  labsProviderTypeId: number = 5;
  radiosProviderTypeId: number = 10;
  fdoProviderTypeId: number = 12;
  labsProviderId: number;
  radiosProviderId: number;
  fdoProviderId: number;
  labsProvidersList: IServiceProvider[];
  radiosProvidersList: IServiceProvider[];
  fdoProvidersList: IServiceProvider[]
  finglodineSubscriptionFieldId: number = 0;
  uploadedFileTypeId: number;
  labsRequestFiles: FileList | null = null;
  radiosRequestFiles: FileList | null = null;
  fdoRequestFiles: FileList | null = null;
  labsResultstFiles: FileList | null = null;
  radiosResultsFiles: FileList | null = null;
  fdoResultsFiles: FileList | null = null;
  labsApprovalRefrence: string | null = null;
  radiosApprovalRefrence: string | null = null;
  fdoApprovalRefrence: string | null = null;
  cityList: City[];
  areaList: Area[];
  moreMenuItems = {};
  previousLabsUpload: ISubscriptionUploadsModel;
  previousRadiosUpload: ISubscriptionUploadsModel;
  previousFDOUpload: ISubscriptionUploadsModel;
  moreSubscriptionInfo: PatientSubscription;
  finglodineSubscriptionData: IFinglodineSubscriptionData


  constructor(
    private patientService: PatientService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private filesService: FilesService,/*use it to download file*/
    private centersService: CentersService,
    private PspPatientService: PSPPatientService,
    private areaService: AreaService,
    private cityService: CityService,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) {
    this.patientId = this.activatedRoute.snapshot.params.patientId
    this.subscriptionId = this.activatedRoute.snapshot.params.subscriptionId
  }

  ngOnInit(): void {
    this.getPatientInfo(this.patientId);
    this.getPatientPSPsubscriptions(this.patientId);
    this.getFinglodineSubscription(this.subscriptionId);
    this.getlabsProviders(this.labsProviderTypeId);
    this.getRadiosProviders(this.radiosProviderTypeId);
    this.getFdoProviders(this.fdoProviderTypeId)
  }

  getPatientInfo(patientId) {
    this.patientService.getPspPatientDetails(patientId)
      .subscribe(res => {
        this.patientInfo = res.data.personalInfo
        this.getPatientSubscriptionDetails(res)
      })
  }

  getPatientSubscriptionDetails(res) {
    this.patient = res.data;
    for (let index = 0; index < this.patient.addresses.length; index++) {
      this.moreMenuItems[index] = false;
    }

    if (this.patient.personalInfo.areaId) {
      this.areaService
        .getStringAreaName(this.patient.personalInfo.areaId)
        .subscribe((res) => {
          this.patient.personalInfo.areaName = res.data.enName;
        });
    }
    this.cityService.getAllCities().subscribe((res) => {
      this.cityList = res;
      if (this.patient.personalInfo.cityId) {
        this.patient.personalInfo.cityName = this.cityList.find(
          (city) => city.id === this.patient.personalInfo.cityId
        )?.enName;
      }
      this.patient.addresses.map((address) => {
        address.cityName = this.cityList.find(
          (city) => city.id === address.cityId
        )?.enName;
        this.areaService
          .getStringAreaName(address.areaId)
          .subscribe((res) => {
            address.areaName = res.data.enName;
            this.spinner.hide();
          });
      });
    });
    this.spinner.hide();
  }

  getPatientPSPsubscriptions(patientId) {
    this.patientService.getPatientPspSubscriptions(patientId)
      .subscribe(response => {
        this.PSPpatientSubscription = response.data.subscriptions.find(subscription => {
          return subscription.id === +this.subscriptionId;
        });
      })
  }

  getFinglodineSubscription(subscriptionId) {
    this.patientService.getFinglodineSubscriptionData(subscriptionId)
      .subscribe(response => {
        this.finglodineSubscriptionData = response.data;
        if (this.finglodineSubscriptionData && this.finglodineSubscriptionData.uploadingPSPFiles) {
          const previousUploadsWithFileType3 = this.finglodineSubscriptionData.uploadingPSPFiles.filter(upload => upload.fileTypeId === 3);
          if (previousUploadsWithFileType3.length > 0) {
            this.previousLabsUpload = previousUploadsWithFileType3[previousUploadsWithFileType3.length - 1];
          } else {
            this.previousLabsUpload = null;
          }
          const previousUploadsWithFileType4 = this.finglodineSubscriptionData.uploadingPSPFiles.filter(upload => upload.fileTypeId === 4);
          if (previousUploadsWithFileType4.length > 0) {
            this.previousRadiosUpload = previousUploadsWithFileType4[previousUploadsWithFileType4.length - 1];
          } else {
            this.previousRadiosUpload = null;
          }
          const previousUploadsWithFileType5 = this.finglodineSubscriptionData.uploadingPSPFiles.filter(upload => upload.fileTypeId === 5);
          if (previousUploadsWithFileType5.length > 0) {
            this.previousFDOUpload = previousUploadsWithFileType5[previousUploadsWithFileType5.length - 1];
          } else {
            this.previousFDOUpload = null;
          }
        }
      });
  }


  downloadNationalIdFile() {
    this.filesService.downloadMultipleFiles(this.finglodineSubscriptionData.nationalIdPaths);
  }

  downloadMedicalReportsFiles() {
    this.filesService.downloadMultipleFiles(this.finglodineSubscriptionData.medicalReportPaths);
  }

  openAttachmentModal(attachmentUrl: string) {
    const modalRef = this.modalService.open(ViewAttachmentComponent, { size: 'lg' });
    modalRef.componentInstance.rxAttachmentUrl = attachmentUrl;
}


  getlabsProviders(typeId) {
    this.centersService.getServiceProviderById(typeId)
      .subscribe(res => {
        this.labsProvidersList = res.data
      })
  }

  getRadiosProviders(typeId) {
    this.centersService.getServiceProviderById(typeId)
      .subscribe(res => {
        this.radiosProvidersList = res.data
      })
  }

  getFdoProviders(typeId) {
    this.centersService.getServiceProviderById(typeId)
      .subscribe(res => {
        this.fdoProvidersList = res.data
      })
  }

  onLabsFileSelected(files: FileList | null, fileType: string): void {
    if (files !== null) {
      if (fileType === 'result') {
        this.labsResultstFiles = files;
      } else if (fileType === 'request') {
        this.labsRequestFiles = files;
      }
    }
  }

  onRadiosFileSelected(files: FileList | null, fileType: string): void {
    if (files !== null) {
      if (fileType === 'result') {
        this.radiosResultsFiles = files;
      } else if (fileType === 'request') {
        this.radiosRequestFiles = files;
      }
    }
  }

  onFDOFileSelected(files: FileList | null, fileType: string): void {
    if (files !== null) {
      if (fileType === 'result') {
        this.fdoResultsFiles = files;
      } else if (fileType === 'request') {
        this.fdoRequestFiles = files;
      }
    }
  }

  isLabsFormNotValid() {
    return Boolean((!this.labsRequestFiles && !this.labsResultstFiles) || !this.labsProviderId || !(this.PSPpatientSubscription.program.name === "Fingolidine 0.5mg"))
  }

  isRadiosFormNotValid() {
    return Boolean((!this.radiosRequestFiles && !this.radiosResultsFiles) || !this.radiosProviderId) || !(this.PSPpatientSubscription.program.name === "Fingolidine 0.5mg")
  }

  isFDOFormNotValid() {
    return Boolean((!this.fdoRequestFiles && !this.fdoResultsFiles) || !this.fdoProviderId) || !(this.PSPpatientSubscription.program.name === "Fingolidine 0.5mg")
  }


  downloadLabsAttachements() {
    const fileUrls = [];
    const requestFileUrls = this.previousLabsUpload.requestFilePaths
    const resultFileUrls = this.previousLabsUpload.resultFilePaths
    fileUrls.push(...requestFileUrls, ...resultFileUrls);
    this.filesService.downloadMultipleFiles(fileUrls);
  }

  downloadRadiosAttachements() {
    const fileUrls = [];
    const requestFileUrls = this.previousRadiosUpload.requestFilePaths
    const resultFileUrls = this.previousRadiosUpload.resultFilePaths
    fileUrls.push(...requestFileUrls, ...resultFileUrls);
    this.filesService.downloadMultipleFiles(fileUrls);
  }

  downloadFDOAttachements() {
    const fileUrls = [];
    const requestFileUrls = this.previousFDOUpload.requestFilePaths
    const resultFileUrls = this.previousFDOUpload.resultFilePaths
    fileUrls.push(...requestFileUrls, ...resultFileUrls);
    this.filesService.downloadMultipleFiles(fileUrls);
  }


  uploadLabsData(): void {
    const formData: FormData = new FormData();
    if (!this.previousLabsUpload) {
      formData.append('Id', '0');
    } else {
      formData.append('Id', this.previousLabsUpload.id.toString());
    }
    this.uploadedFileTypeId = 3;
    formData.append('FileTypeId', this.uploadedFileTypeId.toString());
    formData.append('ProviderId', this.labsProviderId.toString());
    if (this.labsRequestFiles !== null) {
      for (let i = 0; i < this.labsRequestFiles.length; i++) {
        formData.append('RequestFiles', this.labsRequestFiles[i]);
      }
    }
    if (this.labsResultstFiles !== null) {
      for (let i = 0; i < this.labsResultstFiles.length; i++) {
        formData.append('ResultFiles', this.labsResultstFiles[i]);
      }
    }
    formData.append('ApprovalReference', this.labsApprovalRefrence);
    formData.append('SubscriptionId', this.subscriptionId.toString());
    this.PspPatientService.uploadPspfinglodineSubscriptionlData(formData).subscribe({
      next: (response) => {
        showNotification(
          'success',
          'Lab Tests Data has been uploaded successfully',
          this.toastr
        );
      }
    })
  }

  uploadRadiosData(): void {
    const formData: FormData = new FormData();
    if (!this.previousRadiosUpload) {
      formData.append('Id', '0');
    } else {
      formData.append('Id', this.previousRadiosUpload.id.toString());
    }
    this.uploadedFileTypeId = 4;
    formData.append('FileTypeId', this.uploadedFileTypeId.toString());
    formData.append('ProviderId', this.radiosProviderId.toString());
    if (this.radiosResultsFiles !== null) {
      for (let i = 0; i < this.radiosResultsFiles.length; i++) {
        formData.append('ResultFiles', this.radiosResultsFiles[i]);
      }
    }
    if (this.radiosRequestFiles !== null) {
      for (let i = 0; i < this.radiosRequestFiles.length; i++) {
        formData.append('RequestFiles', this.radiosRequestFiles[i]);
      }
    }
    formData.append('ApprovalReference', this.radiosApprovalRefrence);
    formData.append('SubscriptionId', this.subscriptionId.toString());
    this.PspPatientService.uploadPspfinglodineSubscriptionlData(formData).subscribe({
      next: (response) => {
        showNotification(
          'success',
          'Radiologies Data has been uploaded successfully',
          this.toastr
        );
      }
    })
  }

  uploadFdoData(): void {
    const formData: FormData = new FormData();
    if (!this.previousFDOUpload) {
      formData.append('Id', '0');
    } else {
      formData.append('Id', this.previousFDOUpload.id.toString());
    }
    this.uploadedFileTypeId = 5;
    formData.append('FileTypeId', this.uploadedFileTypeId.toString());
    formData.append('ProviderId', this.fdoProviderId.toString());
    if (this.fdoResultsFiles !== null) {
      for (let i = 0; i < this.fdoResultsFiles.length; i++) {
        formData.append('ResultFiles', this.fdoResultsFiles[i]);
      }
    }
    if (this.fdoRequestFiles !== null) {
      for (let i = 0; i < this.fdoRequestFiles.length; i++) {
        formData.append('RequestFiles', this.fdoRequestFiles[i]);
      }
    }
    formData.append('ApprovalReference', this.fdoApprovalRefrence);
    formData.append('SubscriptionId', this.subscriptionId.toString());
    this.PspPatientService.uploadPspfinglodineSubscriptionlData(formData).subscribe({
      next: (response) => {
        showNotification(
          'success',
          'FDO Data has been uploaded successfully',
          this.toastr
        );
      }
    })
  }
}